import React from 'react';
import { NORTH_CAROLINA, PENNSYLVANIA } from '../constants';
import { GenericChoice, Qualification } from '../types';
import { NorthCarolinaRequirements } from '../components/northcarolina/NorthCarolinaRequirements';
import { PennsylvaniaRequirements } from '../components/pennsylvania/PennsylvaniaRequirements';

export const stateSpecificRequirements = {
    [NORTH_CAROLINA]: NorthCarolinaRequirements,
    [PENNSYLVANIA]: PennsylvaniaRequirements,
};

export function hasStateSpecificRequirements(state: string): boolean {
    return state in stateSpecificRequirements;
}

export function StateSpecificRequirements({
    state,
    update,
}: {
    state: string;
    update: (
        value: number | number[],
        choices: GenericChoice[],
        qualification: Qualification | null,
        category: 'education' | 'experience' | 'multiple' | 'single' | 'boolean',
    ) => void;
}) {
    const StateSpecificRequirement = hasStateSpecificRequirements(state)
        ? stateSpecificRequirements[state as keyof typeof stateSpecificRequirements]
        : null;

    return StateSpecificRequirement ? <StateSpecificRequirement update={update} /> : null;
}
